/**
 * Swiper file to put all the site sliders in.
 */

import Swiper, { Navigation } from 'swiper';

jQuery( $ => {
	/**
	 * Swiper that is shown on all archive/shop/tax-pages
	 * Slider content can be found in archive-popular-products.php
	 */
	const popularProductsSliderSettings = {
		modules: [ Navigation ],
		preventClicks: true,
		preventClicksPropagation: true,
		loop: true,
		spaceBetween: 10,
		// Default parameters
		slidesPerView: 2,
		slidesPerGroup: 2,
		// Responsive breakpoints
		breakpoints: {
			// when window width is >= 576px
			576: {
				slidesPerView: 4,
				slidesPerGroup: 4,
			},
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	};

	// Grab popular-product-slider's and create a new Swiper instance for each of them
	const popularProductsSlider = document.querySelectorAll( '.popular-products-slider' );
	[ ...popularProductsSlider ].forEach( popularProductsSlide => {
		// Find parent container and grab the actual navigation for the slider
		const outerWrapper = popularProductsSlide.closest( '.container' );

		popularProductsSliderSettings.navigation.nextEl = outerWrapper.querySelector( '.swiper-button-next' );
		popularProductsSliderSettings.navigation.prevEl = outerWrapper.querySelector( '.swiper-button-prev' );

		new Swiper( popularProductsSlide, popularProductsSliderSettings );
	} );

	/**
	 * Generic products slider.
	 * Used on for example cross-sells on single product.
	 */
	const productsCarouselSliderSettings = {
		modules: [ Navigation ],
		preventClicks: true,
		preventClicksPropagation: true,
		spaceBetween: 10,
		// Default parameters
		slidesPerView: 2,
		slidesPerGroup: 2,
		// Responsive breakpoints
		breakpoints: {
			// when window width is >= 576px
			576: {
				slidesPerView: 4,
				slidesPerGroup: 4,
			},
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	};

	// Grab all product-slider's and create a new Swiper instance for each of them
	const productsCarouselSlider = document.querySelectorAll( '.products-slider' );
	[ ...productsCarouselSlider ].forEach( productsCarouselSlide => {
		// Find parent container and grab the actual navigation for the slider
		const outerWrapper = productsCarouselSlide.closest( '.container' );

		productsCarouselSliderSettings.navigation.nextEl = outerWrapper.querySelector( '.swiper-button-next' );
		productsCarouselSliderSettings.navigation.prevEl = outerWrapper.querySelector( '.swiper-button-prev' );

		new Swiper( productsCarouselSlide, productsCarouselSliderSettings );
	} );

	/**
	 * Grid slider
	 * Will turn a regular grid into a slider at specified breakpoint.
	 */
	if ( window.innerWidth <= 576 ) {
		const gridCarousel = $( '[class*=grid-slider]' );
		if ( 0 < gridCarousel.length ) {
			const gridSliderSettings = {
				preventClicks: true,
				preventClicksPropagation: true,
				spaceBetween: 10,
			};

			const gridSlider = document.querySelectorAll( '[class*=grid-slider]' );
			[ ...gridSlider ].forEach( gridSlide => {
				new Swiper( gridSlide, gridSliderSettings );
			} );
		}
	}
} );
